import { render, staticRenderFns } from "./FormPersonalRate.vue?vue&type=template&id=6a3165da&"
import script from "./FormPersonalRate.vue?vue&type=script&lang=ts&"
export * from "./FormPersonalRate.vue?vue&type=script&lang=ts&"
import style0 from "./FormPersonalRate.vue?vue&type=style&index=0&id=6a3165da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports